module.exports = __webpack_public_path__ + "img/pic4.3f3cc132.png";